export const schema = {
  action: {
    copyField: "Copier le champ",
    deleteField: "Supprimer le champ",
    editField: "Modifier le champ",
    previewField: "Aperçu",
  },
  fieldType: {
    assetUnlockToggler: "Actif identifié (NFC, QR, …)",
    checkbox: "Case à cocher",
    defects: "Liste déroulante des défauts",
    expression: "Valeur calculée",
    inspectedComponent: "Sélecteur de composante",
    label: "Titre",
    materials: "Liste déroulante des matériaux",
    number: "Saisie numérique",
    select: "Liste déroulante",
    severities: "Liste déroulante des critères de sévérité",
    text: "Saisie de texte",
    textArea: "Zone de texte",
  },
  property: {
    description: "Description",
    fieldType: "Type de champ",
    hint: "Indice",
    label: "Titre",
    max: "Maximum",
    min: "Minimum",
    model: "Clé du modèle",
    placeholder: "Exemple/Conseil",
    precision: "Nombre de décimales",
    rows: "Nombre de lignes",
    unit: "Unité de mesure",
  },
  conditions: {
    title: "Conditions de visibilité",
    add: "Ajouter une condition de visibilité",
    delete: "Supprimer la condition de visibilité",
    tooltip:
      "Ce champ sera visible si au moins une des conditions suivantes est vraie.",
    rowTitle: "Condition {{index}}",
    model: {
      placeholder: "Champ",
      missing: "Veuillez sélectionner un champ",
    },
    operator: {
      placeholder: "Opération",
      missing: "Veuillez sélectionner une opération",
    },
    value: {
      placeholder: "Valeur",
      missing: "Veuillez indiquer une valeur",
    },
  },
  select: {
    title: "Valeurs de la liste déroulante",
    add: "Ajouter un ensemble de valeurs",
    delete: "Supprimer l'ensemble de valeurs",
    tooltip:
      "Un ensemble de valeurs devient visible dans la liste dès qu'au moins une de ses conditions de visibilité est satisfaite.",
    values: {
      label: "Ensemble de valeurs {{index}}",
      missing: "Veuillez ajouter au moins un ensemble de valeurs",
    },
    copy: {
      tooltip: "Copier les valeurs",
      message: "Valeurs copiées dans le presse papier!",
    },
  },
  expression: {
    label: "Formule mathématique",
    placeholder:
      "Entrer une formule ex: 2.54 * sqrt((ax - bx)^2 + (ay - by)^2 + (az-bz)^2)/2",
    hint: {
      1: "Opérations supportées: <strong>+ - * / ^</strong> (exposant)",
      2: "Fonctions supportées: <strong>sqrt</strong>(expression), <strong>min</strong>(expression1, expression2, ...), <strong>max</strong>(expression1, expression2, ...), <strong>coalesce</strong>(expression1, expression2, ...)",
      3: "Variables: Vous pouvez utiliser des lettres et tirets bas, ex: <strong>a b temp_celsius</strong>",
      4: "Constantes: Vous pouvez utiliser un entier, un nombre décimal ou une fraction, ex: <strong>10 3.141 5/7</strong>",
    },
    variables: {
      title: "Assignation des variables",
      placeholder: "Champ numérique du formulaire",
      requiredError: "Veuillez sélectionner un champ numérique",
    },
  },
};
